/* tslint:disable */

declare var Object: any;
export interface SfPayslipInterface {
  "id"?: number;
}

export class SfPayslip implements SfPayslipInterface {
  "id": number;
  constructor(data?: SfPayslipInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SfPayslip`.
   */
  public static getModelName() {
    return "SfPayslip";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SfPayslip for dynamic purposes.
  **/
  public static factory(data: SfPayslipInterface): SfPayslip{
    return new SfPayslip(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SfPayslip',
      plural: 'sfPayslip',
      path: 'sfPayslip',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SfPayslip.ts